import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BroadcastService } from 'app/core/services/broadcast.service';
import { CommonService } from 'app/core/services/common.service';
import { EmployeePayrollService } from 'app/core/services/employee-payroll.service';
import { ImportTimesheetService } from 'app/core/services/import-timesheet.service';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { RefreshHolidayService } from 'app/core/services/refresh-holiday/refresh-holiday.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'dialog-delete',
  templateUrl: './dialog-delete.component.html',
  styleUrls: ['./dialog-delete.component.scss']
})
export class DialogDeleteComponent implements OnInit {

  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private importTimesheetService: ImportTimesheetService,
    private employeePayrollService: EmployeePayrollService,
    private commonService: CommonService,
    private refreshHolidayService: RefreshHolidayService,
    private broadcastService: BroadcastService,
    private payrollProcessService: PayrollProcessService
  ) { }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close(false); // Return false when cancelled
  }

  delete() {
    this.isLoading = true;

    if (this.data.type === 'ImportTimesheet') {
      this.importTimesheetService.deleteTimeEntries(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.index);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting time entries:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'Timesheet') {
      this.importTimesheetService.deleteTimesheet(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.index);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting timesheet:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'Payroll') {
      this.employeePayrollService.deletePayroll(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.index);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting payroll:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'Client') {
      this.commonService.deleteClient(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.index);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting client:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'broadcast-message') {
      this.broadcastService.delete_broadcast_message(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.id);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting broadcast message:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'client-registration') {
      this.commonService.deleteSPClient(this.data.id).subscribe({
        next: (res) => {
          this.refreshHolidayService.emitRefresh2(this.data.id);
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting client registration:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'ImportTimesheetBulk') {
      forkJoin(this.data.ids.map((id: number) => this.importTimesheetService.deleteTimeEntries(id))).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error deleting time entries:', err);
          this.dialogRef.close(false);
        }
      });
    }
    else if (this.data.type === 'timesheet-line') {
      this.importTimesheetService.deleteTimesheetLine(this.data.id).subscribe({
        next: (res) => {
          // Don't emit refresh here - let the parent component handle UI updates
          this.isLoading = false;
          this.dialogRef.close(true); // Return true on success
        },
        error: (err) => {
          this.isLoading = false; // Fixed: was setting to true
          console.error('Error deleting timesheet line:', err);
          this.dialogRef.close(false); // Return false on error
        },
      });
    }
    else if (this.data.type === 'Timesheet-bulk') {
      forkJoin(this.data.ids.map((id: number) => this.importTimesheetService.deleteTimesheet(id))).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error deleting timesheets:', err);
          this.dialogRef.close(false);
        }
      });
    }
    else if (this.data.type === 'PayrollProcess-bulk') {
      forkJoin(this.data.ids.map((id: number) => this.payrollProcessService.deleteProcess(id))).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error deleting payroll processes:', err);
          this.dialogRef.close(false);
        }
      });
    }
    else if (this.data.type === 'Payroll-bulk') {
      forkJoin(this.data.ids.map((id: number) => this.employeePayrollService.deletePayroll(id))).subscribe({
        next: () => {
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error deleting payrolls:', err);
          this.dialogRef.close(false);
        }
      });
    }
  }
}